import { render, staticRenderFns } from "./column-input.vue?vue&type=template&id=7463b5a0&scoped=true&"
import script from "./column-input.vue?vue&type=script&lang=js&"
export * from "./column-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463b5a0",
  null
  
)

export default component.exports